/**
 * Shared helpers for reading widget configuration values
 * from the dataSources array regardless of source type.
 */

/**
 * Find the first relevant data source config from a widget config.
 * Checks 'table' first, then 'custom_query'.
 *
 * @param {Object} config - Widget config object (widget.config)
 * @returns {Object} The data source's inner config, or {}
 */
export const getDataSourceConfig = (config) => {
  const ds = config?.dataSources?.find((s) => s.type === 'table')
    || config?.dataSources?.find((s) => s.type === 'custom_query');
  return ds?.config || {};
};

/**
 * Get the category limit for chart widgets.
 * Reads from the data source config (table or custom_query),
 * falling back to the legacy config.maxSlices.
 *
 * @param {Object} config - Widget config object (widget.config)
 * @returns {number|undefined} Category limit, or undefined if not set
 */
export const getCategoryLimit = (config) => {
  const dsConfig = getDataSourceConfig(config);
  return dsConfig.categoryLimit || config?.maxSlices;
};
